@if (authors.length > 0) {
  @for (author of authors; track author) {
    <div>
      @if (author.nickname) {
        <div>{{ author.nickname }}</div>
      }
    </div>
  }
}
